import React, { useContext } from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import Login from "../pages/Login";
import Profile from "../pages/Profile";
import Home from "../pages/Home";
import ForgotPassword from "../pages/ForgotPassword";
import useAuth from "../hooks/useAuth";
import Schedule from "../pages/Schedules";
import ValidationsPage from "../pages/Validations";
import DocumentsPage from "../pages/Documents";
import PaymentsPage from "../pages/Payments";
import MainLayout from "../layouts/MainLayout";
import AuthLayout from "../layouts/AuthLayout";
import Dashboard from "../pages/Dashboard";
import ActsPage from "../pages/Acts";
import CurrentAccountPage from "../pages/current-account";
import InvoicingPage from "../pages/Invoicing";
import EsquebrasPage from "../pages/Esquebras/List";
import EsquebrasUsagePage from "../pages/Esquebras/UsageList";

const Private = ({ Item }) => {
    const { isAuthenticated } = useAuth();
    return isAuthenticated ? <Item /> : <Login />;
};

/* const Private = ({ Item }) => {
    const { isAuthenticated } = useAuth();
    return <Item />
}; */

const UnPrivate = ({ Item }) => {
    const { isAuthenticated } = useAuth();

    if (!isAuthenticated) {
        return <Item />;
    }
    return <Navigate to={'/home'} replace />;
};

const ModifiedMainLayout = () => {
    return (
        <MainLayout>
            <Outlet />
        </MainLayout>
    )
};

const ModifiedAuthLayout = () => {
    return (
        <AuthLayout>
            <Outlet />
        </AuthLayout>
    )
};


const AppRoutes = () => {
    const { isAuthenticated } = useAuth();


    return (

        <>
            {isAuthenticated ?
                <Routes>
                    <Route element={<ModifiedMainLayout />}>
                        <Route path="/*">
                            <Route index element={<Dashboard />}/>
                            <Route path="documents" element={<DocumentsPage />} />
                            <Route path='schedules' element={<Schedule />} />
                            <Route path="validations" element={<ValidationsPage />} />
                            <Route path="current-account" element={<CurrentAccountPage />} />
                            <Route path="acts" element={<ActsPage />} />
                            <Route path="esquebras" element={<EsquebrasPage/>} />
                            <Route path="esquebras/usages" element={<EsquebrasUsagePage/>} />
                        </Route>
                    </Route>
                </Routes>
                :
                <React.Fragment>
                    <Routes>
                        <Route element={<ModifiedAuthLayout />}>
                            <Route path="/" element={<UnPrivate Item={Login} />} />
                            <Route path="/reset-password" element={<UnPrivate Item={ForgotPassword} />} />

                        </Route>
                    </Routes>
                </React.Fragment>
            }
        </>
    )
}

export default AppRoutes;